import React from "react"
import { Outlet } from "react-router-dom"
import { Box, useTheme } from "@mui/material"

import { useTranslation } from "providers/i18n"
import { useGeoLocation } from "providers/geolocation"
import { Head } from "components/Head"

export const Layout = () => {
  const { userLocation, scannedLocations, deviceLocation } = useGeoLocation()
  const { t } = useTranslation()
  const theme = useTheme()
  const styleOverrides = theme.components[`AppMapLayout`]?.styleOverrides || {}
  const { mapContainer, outletWrapper } = styleOverrides

  return (
    <>
      <Head title={t("Map")} />
      <Box sx={mapContainer}>
        <Box sx={outletWrapper}>
          <Outlet
            context={
              {
                scannedLocations,
                userLocation,
                deviceLocation,
              } || {}
            }
          />
        </Box>
      </Box>
    </>
  )
}
